import { Component, Vue, Watch } from 'vue-property-decorator';
import apiRequest from '../../../service/vpc/request';
import trustApiRequest from '../../../service/trust_vpc/request';
import * as _ from 'lodash';

import Dialog from 'kpc/components/dialog';
import { Table, TableColumn } from 'kpc/components/table';
import Icon from 'kpc/components/icon';
import { Form, FormItem } from 'kpc/components/form';
import { Button, ButtonGroup } from 'kpc/components/button';
import Input from 'kpc/components/input';
import Spin from 'kpc/components/spin';
import { Tabs, Tab } from 'kpc/components/tabs';
import Message from 'kpc/components/message';

import TableWithPagination from "../../../components/TableWithPagination/index.vue";
import getChargeTypeChina from '../../../service/common/getChargeTypeChina';

@Component({
    components: {
        Dialog,
        Table, TableColumn,
        Icon,
        Form, FormItem,
        Button, ButtonGroup,
        Input,
        TableWithPagination,
        Spin,
        Tabs, Tab
    }
})
export default class GroupBatchRemoveDialog extends Vue {
    show = false;
    cb?: () => void;
    region = '';
    getChargeTypeChina = getChargeTypeChina;
    list: any[] = [];

    get disabledOk() {
        return this.list.length === 0;
    }

    get request() {
        return this.$route.path.indexOf('trust-vpc') !== -1 ? trustApiRequest : apiRequest
    }

    deleteBtn() {
        let me: any = this;
        window.KscCheck({
            level: 2,
            success: () => {
                me.deleteGroup()
            }
        }).init();
    }

    deleteGroup() {
        let dialog: any = this.$refs.dialog;
        dialog.showLoading();

        let ids = _.map(this.list, item => item.SecurityGroupId)

        // apiRequest.DeleteSecurityGroups({
        this.request.DeleteSecurityGroups({
            Region: this.region,
            ids: ids.join(',')
        }).done((data: any) => {
            if (data && data.Return) {
                Message.success(this.$trans(`删除成功`));
            }

            this.show = false;
            this.cb && this.cb();
        }).always(() => {
            this.show = false;
            dialog.hideLoading();
        });
    }

    public open(region: string, list: any[], cb: any) {
        this.region = region;
        this.cb = cb;
        this.list = list;
        this.show = true;
    }

};

